export default () => {
  function currencyFlagIcon(currency: string) {
    let name = '';
    switch (currency) {
      case 'CHF':
        name = 'CHE';
        break;
      case 'EUR':
        name = 'EUR';
        break;
      case 'USD':
        name = 'USA';
        break;
      case 'CAD':
        name = 'CAN';
        break;
      case 'GBP':
        name = 'GBR';
        break;
      case 'AUD':
        name = 'AUS';
        break;
      case 'THB':
        name = 'THA';
        break;
      case 'BZD':
        name = 'BLZ';
        break;
      case 'DKK':
        name = 'DNK';
        break;
      default:
        name = currency.toUpperCase();
        break;
    }
    return name;
  }

  return {
    currencyFlagIcon
  };
};
